import React from 'react';
import { Link } from "react-router-dom";

const footer = () => {
    const currentYear = new Date().getFullYear();
    return(
        <footer>
            <div className="container">
                <div className="row gx-5">
                    <div className="col-lg-4">
                        <img src="./img/logo.png" width="100" alt="Fetron" />
                        <div className="spacer-20"></div>
                        <p>- Filiada à Confederação Brasileira de Taekwondo em 03 de abril de 2003</p>
                        <p>- Utilidade Pública Municipal - Lei Orgânica Nº 3.422/2016 de 20 de junho de 2016</p>
                        <p>- Utilidade Pública Estadual - Lei Nº 417/16 de 02 de agosto de 2016</p>
                        <p>- CNPJ - 05.532.821/0001-92</p>
                    </div>
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-lg-6 col-sm-6">
                                <div className="widget">
                                    <h5>Navegue</h5>
                                    <ul>
                                        <li><Link to="/quem-somos">Quem Somos</Link></li>
                                        <li><Link to="/documentos">Documentos</Link></li>
                                        <li><Link to="/calendario">Eventos</Link></li>
                                        <li><Link to="/noticias">Noticias</Link></li>
                                        <li><Link to="/academias">Academias</Link></li>
                                        <li><Link to="/contato">Contato</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-6">
                                <div className="widget">
                                    <h5>Contato</h5>
                                    <ul>
                                        <li>R.Raimundo Cantuária, 5681</li>
                                        <li>Tiradentes, Porto Velho - RO</li>
                                        <li>Tel: (69) 99360-9680</li>
                                        <li>Email: tesourariafetron@gmail.com</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="widget">
                            <h5>Siga a FETRON</h5>
                            <div className="widget">
                                <div className="social-icons">
                                    <Link to="https://www.facebook.com/fetronoficial/?locale=pt_BR" target='blank'><i className="fa-brands fa-facebook-f"></i></Link>
                                    <Link to="https://www.instagram.com/fetron_tkd2/" target='blank'><i className="fa-brands fa-instagram"></i></Link>
                                    <Link to="/https://www.youtube.com/channel/UCZXNG3Chg4zgojHtDkGjfwg" target='blank'><i className="fa-brands fa-youtube"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">
                           Copyright {currentYear} - Desenvolvido por <Link to="https://bleepdigital.com.br">Bleep Digital</Link>
                        </div>
                        <div className="col-lg-6 col-sm-6 text-lg-end text-sm-start">
                            <ul className="menu-simple">
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default footer;